export const headerContent = {
  en: {
    about: 'About',
    download: 'Download Data',
    mapThemes: 'Map Themes',
    myGFWLogin: 'Log in to my GFW',
    myGFW: 'MY GFW',
    loginReq:
      'Log in is required so you can return to Global Forest Watch to view, manage, and delete your subscriptions. Questions? ',
    contactUs: 'Contact us at gfw@wri.org',
    twitter: 'Log in with Twitter',
    facebook: 'Log in with Facebook',
    google: 'Log in with Google',
    subscriptions: 'My Subscriptions',
    stories: 'My Stories',
    profile: 'My GFW Profile',
    logout: 'Log Out',
    language: 'Select Language',
  },
  az: {
    about: 'About',
    download: 'məlumatları yükləyin',
    mapThemes: 'Map Themes',
    myGFWLogin: 'Mənim GFW hesabıma giriş',
    myGFW: 'Mənim GFW hesabım',
    loginReq:
      'Abunələrinizi nəzərdən keçirmək, idarə etmək və silmək üçün Global Forest Watch-a qayıda bilməniz üçün qeydiyyat tələb olunur. Sualınız varmı? ',
    contactUs: 'gfw@wri.org vasitəsilə bizimlə əlaqə saxlayın',
    twitter: 'Twitter vasitəsilə daxil olun',
    facebook: 'Facebook vasitəsilə daxil olun',
    google: 'Google vasitəsilə daxil olun',
    subscriptions: 'Mənim Abunələrim',
    stories: 'Mənim Hekayələrim',
    profile: 'Mənim GFW profilim',
    logout: 'Çıxış',
    language: 'Dili seçin',
  },
  nl: {
    about: 'Over ons',
    download: 'Download Data',
    mapThemes: 'Map Themes', // * NOTE: doesn't exist in translations document
    myGFWLogin: 'Log in mijn GFW',
    myGFW: 'Mijn GFW',
    loginReq:
      'Inloggen is vereist zodat u kunt terugkeren naar Global Forest Watch om uw abonnementen te bekijken, beheren en verwijderen. Vragen?',
    contactUs: 'Contact ons op gfw@wri.org',
    twitter: 'Log in met Twitter',
    facebook: 'Log in met Facebook',
    google: 'Log in met Google',
    subscriptions: 'Mijn abonnementen ',
    stories: 'Mijn verhalen ',
    profile: 'Mijn GFW Profiel',
    logout: 'Log Uit',
    language: 'Kies taal',
  },
  hy: {
    about: 'Մեր մասին',
    download: 'Ներբեռնել տվյալները ',
    mapThemes: 'Map Themes', // * NOTE: doesn't exist in translations document
    myGFWLogin: 'Մուտքագրվել իմ ԱԳՀ էջ',
    myGFW: 'Իմ ԱԳՀ էջ /Անտառների Գլոբալ Հսկողություն/ ',
    loginReq:
      'Անտառների Գլոբալ Հսկողության համակարգ վերադառնալու, Ձեր բաժանորդագրությունը դիտարկելու, կառավարելու և ջնջելու համար անհրաժեշտ է մուտքագրվել: Հարցերի դեպքում խնդրում ենք կապ հաստատել:  ',
    contactUs: 'Մեզ հետ կարող եք կապ հաստատել gfw@wri.org էլ.փոստի միջոցով ',
    twitter: 'Գրանցվել Twitter-ի միջոցով ',
    facebook: 'Գրանցվել Facebook-ի միջոցով ',
    google: 'ԳրանցվելGoogle-ի միջոցով  ',
    subscriptions: 'Իմ բաժանորդագրությունները ',
    stories: 'Իմ պատմությունները ',
    profile: 'Իմ ԱԳՀ հաշիվը/էջը ',
    logout: 'Դուրս գալ ',
    language: 'Ընտրել լեզուն ',
  },
  ka: {
    about: 'პროექტის შესახებ',
    download: 'მონაცემების გადმოწერა',
    mapThemes: 'რუკის თემები',
    myGFWLogin: 'GFW პროფილში შესვლა',
    myGFW: 'GFW',
    loginReq:
      'შესვლა აუცილებელია, იმისათვის, რომ შეძლოთ Global Forest Watch-ში თქვენი გამოწერების ნახვა, მართვა და წაშლა. კითხვები გაქვთ? დაგვიკავშირდით gfw@wri.org მისამართზე ',
    contactUs: 'დაგვიკავშირდით gfw@wri.org მისამართზე ',
    twitter: 'შესვლა Twitter',
    facebook: 'შესვლა Facebook',
    google: 'შესვლა Google',
    subscriptions: 'ჩემი გამოწერები',
    stories: 'My Stories',
    profile: 'ჩემი "GFW" პროფილი',
    logout: 'გამოსვლა',
    language: 'ენის არჩევა',
  },
  fr: {
    about: 'A Propos',
    download: 'Téléchargez les Données',
    mapThemes: 'Thèmes',
    myGFWLogin: 'Se connecter à GFW',
    myGFW: 'GFW',
    loginReq: 'Vous devez être connecté pour afficher, gérer et supprimer vos abonnements. Des questions? ',
    contactUs: 'Contactez-nous',
    twitter: 'Connectez-vous avec Twitter',
    facebook: 'Connectez-vous avec Facebook',
    google: 'Se connecter avec Google',
    subscriptions: 'Mes abonnements',
    stories: 'Mes histoires',
    profile: 'Mon profil',
    logout: 'Déconnecter',
    language: 'Choisir Langue',
  },
  es: {
    about: 'Acerca de',
    download: 'Descargar Datos',
    mapThemes: 'Temas',
    myGFWLogin: 'Entrar a mi GFW',
    myGFW: 'MI GFW',
    loginReq: 'Es necesario iniciar sesión para ver, administrar y eliminar tus suscripciones. ¿Alguna pregunta? ',
    contactUs: 'Contáctanos',
    twitter: 'Ingresar con Twitter',
    facebook: 'Iniciar sesión con Facebook',
    google: 'Iniciar sesión con Google',
    subscriptions: 'Mis suscripciones',
    stories: 'Mis historias',
    profile: 'Mon profil',
    logout: 'Cerrar sesión',
    language: 'Seleccionar idioma',
  },
  pt: {
    about: 'Sobre',
    download: 'Baixar Dados',
    mapThemes: 'Temas do Mapa',
    myGFWLogin: 'Fazer Login no MEU GFW',
    myGFW: 'MEU GFW',
    loginReq: 'É necessário iniciar uma sessão para visualizar, gerenciar e deletar suas assinaturas. Dúvidas? ',
    contactUs: 'Entre em contato',
    twitter: 'Entrar com Twitter',
    facebook: 'Entrar Com Facebook',
    google: 'Entrar Com Google',
    subscriptions: 'Minhas Assinaturas',
    stories: 'My Stories',
    profile: 'Mon profil',
    logout: 'Sair',
    language: 'Selecionar Idioma',
  },
  id: {
    about: 'About',
    download: 'Download Data',
    mapThemes: 'Map Themes',
    myGFWLogin: 'Log in to my GFW',
    myGFW: 'MY GFW',
    loginReq: 'Anda harus masuk untuk dapat melihat, mengelola, serta menghapus langganan Anda. Ada pertanyaan? ',
    contactUs: 'Hubungi kami',
    twitter: 'Masuk dengan Twitter',
    facebook: 'Masuk dengan Facebook',
    google: 'Masuk dengan Google',
    subscriptions: 'Berlangganan Saya',
    stories: 'Cerita Saya',
    profile: 'Mon profil',
    logout: 'Keluar',
    language: 'Select Language',
  },
  zh: {
    about: '关于',
    download: '下载数据',
    mapThemes: '地图图集',
    myGFWLogin: '登录我的GFW',
    myGFW: 'GFW',
    loginReq: '您需要登录以查看、管理或删除您的订阅。 有疑问? ',
    contactUs: '请联系我们',
    twitter: '使用 Twitter 账户登录',
    facebook: 'Log in with Facebook',
    google: '使用谷歌账户登录',
    subscriptions: '我的订阅',
    stories: '我的故事',
    profile: '我的概述',
    logout: '注销',
    language: '选择语言',
  },
};

export const bannerContent = {
  en: {
    text: 'Planet imagery — including all new and historical mosaics — are no longer available on MapBuilder as of April 1, 2025. For more information on this change and an overview of the other satellite imagery already available, please read our ',
    linkUrlText: 'blog.',
    textAfterLink: '',
  },
  az: {
    text: 'Planet təsvirləri - bütün yeni və tarixi mozaikalar da daxil olmaqla - 1 aprel 2025-ci il tarixindən MapBuilder-də mövcud deyil. Bu dəyişiklik haqqında ətraflı məlumat və artıq mövcud olan digər peyk şəkillərinin icmalı üçün lütfən, bloqumuzu ',
    linkUrlText: 'bloqumuzu',
    textAfterLink: ' oxuyun.',
  },
  nl: {
    text: 'Planet beelden - inclusief alle nieuwe en historische mozaïeken - zijn vanaf 1 april 2025 niet langer beschikbaar in MapBuilder. Lees voor meer informatie over deze wijziging en een overzicht van de andere satellietbeelden die al beschikbaar zijn onze ',
    linkUrlText: 'blog.',
    textAfterLink: '',
  },
  hy: {
    text: 'Մոլորակի պատկերները, ներառյալ բոլոր նոր և պատմական խճանկարները, այլևս հասանելի չեն MapBuilder-ում 2025 թվականի ապրիլի 1-ից: Այս փոփոխության վերաբերյալ լրացուցիչ տեղեկությունների և արդեն հասանելի արբանյակային այլ պատկերների ակնարկի համար կարդացեք մեր ',
    linkUrlText: 'բլոգը.',
    textAfterLink: '',
  },
  ka: {
    text: 'პლანეტის გამოსახულებები — მათ შორის ყველა ახალი და ისტორიული მოზაიკის ჩათვლით — აღარ არის ხელმისაწვდომი MapBuilder-ზე 2025 წლის 1 აპრილიდან. დამატებითი ინფორმაციისთვის ამ ცვლილების შესახებ და უკვე ხელმისაწვდომი სხვა სატელიტური სურათების მიმოხილვისთვის, გთხოვთ, წაიკითხოთ ჩვენი ',
    linkUrlText: 'ბლოგი.',
    textAfterLink: '',
  },
  fr: {
    text: "L'imagerie Planet - y compris toutes les mosaïques nouvelles et historiques - n'est plus disponible sur MapBuilder à partir du 1er avril 2025. Pour plus d'informations sur ce changement et une description des autres images satellites déjà disponibles, consulter notre ",
    linkUrlText: 'blog.',
    textAfterLink: '',
  },
  es: {
    text: 'A partir del 1 de abril de 2025, MapBuilder dejará de ofrecer imágenes de Planet, incluidos todos los mosaicos nuevos e históricos. Para más información sobre este cambio y detalles de las demás imágenes de satélite ya disponibles, lea nuestro ',
    textAfterLink: '',
    linkUrlText: 'blog.',
  },
  pt: {
    text: 'As imagens Planet - incluindo todos os mosaicos novos e históricos - não estarão mais disponíveis no MapBuilder a partir de 1º de abril de 2025. Para obter mais informações sobre essa mudança e uma visão geral das outras imagens de satélite já disponíveis, leia nosso ',
    linkUrlText: 'blog.',
    textAfterLink: '',
  },
  id: {
    text: `Citra satelit “Planet” - termasuk semua mosaik baru dan historis - tidak lagi tersedia di MapBuilder per tanggal 1 April 2025. Untuk informasi lebih lanjut mengenai perubahan ini dan gambaran umum mengenai citra satelit lainnya yang sudah tersedia, silakan baca `,
    linkUrlText: 'blog',
    textAfterLink: ' kami.',
  },
  zh: {
    text: '自 2025 年 4 月 1 日起，MapBuilder 不再提供 行星 图像，包括所有新的和历史的马赛克图像。有关这一变化的更多信息以及其他已有卫星图像的概述，请阅读我们的博客',
    linkUrlText: '请阅读我们的博客',
    textAfterLink: '',
  },
};
